/**
 * Simple Modal Utility for AjaxPress Frontend
 */

let modalContainer = null

const createModal = () => {
    if (modalContainer) return modalContainer
    
    modalContainer = document.createElement('div')
    modalContainer.id = 'ajaxpress-reload-modal'
    modalContainer.className = 'ajaxpress-reload-modal'
    modalContainer.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999999;
        display: none;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(2px);
        animation: ajaxpress-modal-fade-in 0.2s ease;
    `
    
    const modalContent = document.createElement('div')
    modalContent.className = 'ajaxpress-reload-modal-content'
    modalContent.style.cssText = `
        background: white;
        border-radius: 12px;
        padding: 24px;
        max-width: 400px;
        width: 90%;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        animation: ajaxpress-modal-scale-in 0.2s ease;
    `
    
    const title = document.createElement('h3')
    title.textContent = 'Reload Page?'
    title.style.cssText = `
        margin: 0 0 12px 0;
        font-size: 18px;
        font-weight: 600;
        color: #1f2937;
    `
    
    const message = document.createElement('p')
    message.textContent = 'Any unsaved changes will be lost.'
    message.style.cssText = `
        margin: 0 0 24px 0;
        font-size: 14px;
        color: #6b7280;
        line-height: 1.5;
    `
    
    const buttonContainer = document.createElement('div')
    buttonContainer.style.cssText = `
        display: flex;
        gap: 12px;
        justify-content: flex-end;
    `
    
    const cancelBtn = document.createElement('button')
    cancelBtn.textContent = 'Cancel'
    cancelBtn.className = 'ajaxpress-reload-cancel'
    cancelBtn.type = 'button'
    cancelBtn.tabIndex = 0
    cancelBtn.style.cssText = `
        padding: 8px 20px;
        border: 1px solid #e5e7eb;
        background: white;
        color: #374151;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.15s ease;
        outline: none;
    `
    cancelBtn.addEventListener('mouseenter', () => {
        cancelBtn.style.background = '#f9fafb'
        cancelBtn.style.borderColor = '#d1d5db'
    })
    cancelBtn.addEventListener('mouseleave', () => {
        cancelBtn.style.background = 'white'
        cancelBtn.style.borderColor = '#e5e7eb'
    })
    cancelBtn.addEventListener('focus', () => {
        cancelBtn.style.outline = '2px solid #3b82f6'
        cancelBtn.style.outlineOffset = '2px'
    })
    cancelBtn.addEventListener('blur', () => {
        cancelBtn.style.outline = 'none'
    })
    
    const reloadBtn = document.createElement('button')
    reloadBtn.textContent = 'Reload'
    reloadBtn.className = 'ajaxpress-reload-confirm'
    reloadBtn.type = 'button'
    reloadBtn.tabIndex = 0
    reloadBtn.style.cssText = `
        padding: 8px 20px;
        border: none;
        background: #ef4444;
        color: white;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.15s ease;
        outline: none;
    `
    reloadBtn.addEventListener('mouseenter', () => {
        reloadBtn.style.background = '#dc2626'
    })
    reloadBtn.addEventListener('mouseleave', () => {
        reloadBtn.style.background = '#ef4444'
    })
    reloadBtn.addEventListener('focus', () => {
        reloadBtn.style.outline = '2px solid #3b82f6'
        reloadBtn.style.outlineOffset = '2px'
    })
    reloadBtn.addEventListener('blur', () => {
        reloadBtn.style.outline = 'none'
    })
    
    buttonContainer.appendChild(cancelBtn)
    buttonContainer.appendChild(reloadBtn)
    
    modalContent.appendChild(title)
    modalContent.appendChild(message)
    modalContent.appendChild(buttonContainer)
    modalContainer.appendChild(modalContent)
    
    // Add backdrop click handler
    modalContainer.addEventListener('click', (e) => {
        if (e.target === modalContainer) {
            hideModal()
        }
    })
    
    // Add CSS animations
    if (!document.getElementById('ajaxpress-modal-styles')) {
        const style = document.createElement('style')
        style.id = 'ajaxpress-modal-styles'
        style.textContent = `
            @keyframes ajaxpress-modal-fade-in {
                from { opacity: 0; }
                to { opacity: 1; }
            }
            @keyframes ajaxpress-modal-scale-in {
                from { 
                    opacity: 0;
                    transform: scale(0.95);
                }
                to { 
                    opacity: 1;
                    transform: scale(1);
                }
            }
            .ajaxpress-reload-modal.show {
                display: flex !important;
            }
        `
        document.head.appendChild(style)
    }
    
    document.body.appendChild(modalContainer)
    return modalContainer
}

let currentResolve = null

export const showReloadModal = () => {
    return new Promise((resolve) => {
        try {
            const modal = createModal()
            if (!modal) {
                console.error('AjaxPress: Failed to create modal')
                resolve(false)
                return
            }
            
            currentResolve = resolve
            
            const cancelBtn = modal.querySelector('.ajaxpress-reload-cancel')
            const reloadBtn = modal.querySelector('.ajaxpress-reload-confirm')
            
            if (!cancelBtn || !reloadBtn) {
                console.error('AjaxPress: Modal buttons not found')
                resolve(false)
                return
            }
            
            const handleCancel = () => {
                hideModal()
                cleanup()
                resolve(false)
            }
            
            const handleReload = () => {
                hideModal()
                cleanup()
                resolve(true)
            }
            
            const handleEscape = (e) => {
                if (e.key === 'Escape') {
                    e.preventDefault()
                    e.stopPropagation()
                    e.stopImmediatePropagation()
                    handleCancel()
                }
            }
            
            const handleEnter = (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault()
                    e.stopPropagation()
                    const activeElement = document.activeElement
                    if (activeElement === reloadBtn) {
                        handleReload()
                    } else if (activeElement === cancelBtn) {
                        handleCancel()
                    }
                }
            }
            
            const handleTab = (e) => {
                // Trap focus within modal and allow switching between buttons
                const focusableElements = [cancelBtn, reloadBtn]
                const firstElement = focusableElements[0]
                const lastElement = focusableElements[focusableElements.length - 1]
                const currentIndex = focusableElements.indexOf(document.activeElement)
                
                if (e.key === 'Tab') {
                    // Only trap if focus is within modal
                    if (currentIndex === -1) {
                        // Focus is outside modal, focus first element
                        e.preventDefault()
                        firstElement.focus()
                        return
                    }
                    
                    if (e.shiftKey) {
                        // Shift + Tab (backward)
                        e.preventDefault()
                        if (currentIndex === 0) {
                            // At first element, wrap to last
                            lastElement.focus()
                        } else {
                            // Move to previous element
                            focusableElements[currentIndex - 1].focus()
                        }
                    } else {
                        // Tab (forward)
                        e.preventDefault()
                        if (currentIndex === focusableElements.length - 1) {
                            // At last element, wrap to first
                            firstElement.focus()
                        } else {
                            // Move to next element
                            focusableElements[currentIndex + 1].focus()
                        }
                    }
                }
            }
            
            const handleArrowKeys = (e) => {
                // Arrow key navigation for switching between buttons
                const focusableElements = [cancelBtn, reloadBtn]
                const currentIndex = focusableElements.indexOf(document.activeElement)
                
                // Only handle if focus is within modal buttons
                if (currentIndex === -1) {
                    // Focus is outside modal, focus first element
                    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                        e.preventDefault()
                        focusableElements[0].focus()
                    }
                    return
                }
                
                if (e.key === 'ArrowRight') {
                    // Move to next button (right)
                    e.preventDefault()
                    e.stopPropagation()
                    const nextIndex = (currentIndex + 1) % focusableElements.length
                    focusableElements[nextIndex].focus()
                } else if (e.key === 'ArrowLeft') {
                    // Move to previous button (left)
                    e.preventDefault()
                    e.stopPropagation()
                    const prevIndex = (currentIndex - 1 + focusableElements.length) % focusableElements.length
                    focusableElements[prevIndex].focus()
                }
            }
            
            const cleanup = () => {
                document.removeEventListener('keydown', handleEscape)
                document.removeEventListener('keydown', handleEnter)
                document.removeEventListener('keydown', handleTab)
                document.removeEventListener('keydown', handleArrowKeys)
                cancelBtn.removeEventListener('click', handleCancel)
                reloadBtn.removeEventListener('click', handleReload)
            }
            
            cancelBtn.addEventListener('click', handleCancel)
            reloadBtn.addEventListener('click', handleReload)
            document.addEventListener('keydown', handleEscape, true)
            document.addEventListener('keydown', handleEnter, true)
            document.addEventListener('keydown', handleTab, true)
            document.addEventListener('keydown', handleArrowKeys, true)
            
            // Show modal
            modal.classList.add('show')
            modal.style.display = 'flex'
            modal.style.opacity = '1'
            
            // Focus the cancel button for better UX (default action)
            setTimeout(() => {
                cancelBtn.focus()
            }, 50)
        } catch (error) {
            console.error('AjaxPress: Error showing reload modal:', error)
            resolve(false)
        }
    })
}

const hideModal = () => {
    if (modalContainer) {
        modalContainer.classList.remove('show')
        setTimeout(() => {
            if (modalContainer && !modalContainer.classList.contains('show')) {
                modalContainer.style.display = 'none'
            }
        }, 200)
    }
}

